<template>
  <main
    class="text-black bg-white box lg:w-40% xl:w-33% rounded-xl h-370px lg:mt-20 2xl:mt-0"
  >
    <component :is="currentView" @toggle-view="toggleCurrentView" />
  </main>
</template>

<script>
export default {
  components: {
    EnterAdminEmail: () =>
      import('@/components/v2/admin-business-auth/EnterAdminEmail.vue'),
    VerifyAdminEmail: () =>
      import('@/components/v2/admin-business-auth/VerifyAdminEmail.vue')
  },
  data () {
    return {
      currentView: 'enter-admin-email'
    }
  },
  methods: {
    toggleCurrentView (view) {
      this.currentView = view
    }
  }
}
</script>

<style scoped>
.box {
  box-shadow:
    0px 0px 1px rgba(3, 2, 7, 0.1),
    0px 16px 24px rgba(3, 2, 7, 0.1);
  border-radius: 16px;
}
>>> .el-form-item__label {
  font-weight: 600;
  color: black;
  margin-bottom: -0.25rem !important;
}
>>> .el-input__inner {
  height: 55px;
  border-radius: 0.5rem !important;
}
</style>
